'use es6';

import { formatToReferencesList } from '../lib/formatReferences';
import { fromJS, List } from 'immutable';
import flattenN from 'transmute/flattenN';
import get from 'transmute/get';
import indexBy from 'transmute/indexBy';
import map from 'transmute/map';
import pipe from 'transmute/pipe';
export default pipe(fromJS, map(entry => entry.get('questions').map(question => question.set('surveyAnalysisUrl', entry.getIn(['survey', 'analysisUrl'])).set('surveyId', entry.getIn(['survey', 'surveyId'])))), flattenN(1), formatToReferencesList({
  getId: get('id'),
  getLabel: get('questionText')
}), List, indexBy(get('id')));